import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-25-vijay-vaitheeswaran-guest.webp";
import ThumbImg from "../../assets/images/conversations/025.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: vv2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .vv2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .vv2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ── HERO ── */
  .vv2-hero { padding-top: 60px; padding-bottom: 60px; }
  .vv2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .vv2-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .vv2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vv2-hero__title.vv2-visible { opacity: 1; transform: translateY(0); }
  .vv2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .vv2-hero__spotify.vv2-visible { opacity: 1; transform: translateY(0); }
  .vv2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .vv2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .vv2-hero__right.vv2-visible { opacity: 1; transform: translateY(0); }

  /* ── YOUTUBE THUMB ── */
  .vv2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .vv2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .vv2-yt-thumb:hover img { opacity: 0.85; }
  .vv2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .vv2-yt-thumb__play img { width: 40px; height: 44px; }
  .vv2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .vv2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ── BODY ── */
  .vv2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vv2-body.vv2-visible { opacity: 1; transform: translateY(0); }
  .vv2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .vv2-body__para:last-child { margin-bottom: 0; }

  /* ── GUEST ── */
  .vv2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vv2-guest.vv2-visible { opacity: 1; transform: translateY(0); }
  .vv2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .vv2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .vv2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .vv2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .vv2-inner { padding-left: 32px; padding-right: 32px; }
    .vv2-hero { padding-top: 32px; padding-bottom: 48px; }
    .vv2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .vv2-hero__title { font-size: 24px; }
    .vv2-hero__left { gap: 16px; }
    .vv2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .vv2-guest__photo-bg { width: 260px; height: 300px; }
    .vv2-guest__name { font-size: 24px; margin-top: 18px; }
    .vv2-body__para { font-size: 14px; margin-bottom: 12px; }
    .vv2-body { padding-bottom: 48px; }
    .vv2-guest { padding-bottom: 48px; }
    .vv2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .vv2-inner { padding-left: 16px; padding-right: 16px; }
    .vv2-hero { padding-top: 51px; padding-bottom: 30px; }
    .vv2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .vv2-hero__left { gap: 30px; }
    .vv2-hero__title { font-size: 30px; }
    .vv2-body__para { font-size: 16px; margin-bottom: 10px; }
    .vv2-guest__title { font-size: 30px; margin-bottom: 20px; }
    .vv2-guest__photo-bg { width: 100%; height: 386px; }
    .vv2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .vv2-body { padding-bottom: 30px; }
    .vv2-guest { padding-bottom: 30px; }
    .vv2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("vv2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP25_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="vv2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 25 Vijay Vaitheeswaran The Economist"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div
      className="vv2-yt-thumb"
      onClick={() => setPlaying(true)}
      role="button"
      aria-label="Play video"
    >
      <img src={ThumbImg} alt="EP 25 Vijay Vaitheeswaran thumbnail" />
      <div className="vv2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="vv2-hero">
      <div className="vv2-inner">
        <div className="vv2-hero__grid">
          <div className="vv2-hero__left">
            <h1 ref={titleRef} className="vv2-hero__title">
              EP 25 | Decoding China's Dominance on EVs Globally | The Economist | Vijay VAITHEESWARAN
            </h1>
            <div ref={spotifyRef} className="vv2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/5dpf34LK3MjJgGJk7LEvAV?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 25 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="vv2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="vv2-body">
      <div className="vv2-inner">
        <p className="vv2-body__para">
          Vijay VAITHEESWARAN, Global Energy &amp; Climate Innovation Editor, of The Economist, London magazine was traveling through India to work on an article featuring the green hydrogen sector in India. We took the opportunity to have him on our podcast on a whistle stop visit to learn about the electric mobility sector in the US and why China dominates this sector globally.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="vv2-guest">
      <div className="vv2-inner">
        <h2 className="vv2-guest__title">Our Guest</h2>
        <div>
          <div className="vv2-guest__photo-bg">
            <img src={GuestImg} alt="Vijay Vaitheeswaran" />
          </div>
          <p className="vv2-guest__name">Vijay VAITHEESWARAN</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep25VijayVaitheeswaran() {
  return (
    <>
      <style>{CSS}</style>
      <div className="vv2-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}